// "Pause all notifications" also pauses AI auto-replies: the backend turns a reply
// that would have been auto-sent into a suggestion while a guest's notifications are
// paused (cplanetbackend Tour_Operator.auto_reply_blocked_for_paused_notifications).
// The labels mention the AI only where the operator auto-sends (auto_reply_with_ai);
// suggest-only operators keep the plain wording. The backend gate does not depend on
// this setting, so turning auto-reply on later relabels guests who are already paused.
export const aiAutoRepliesOn = () => {
  try {
    const bootstrap = JSON.parse(window.localStorage.getItem('bootstrap') || '{}');
    return !!bootstrap?.tour_operator?.config?.auto_reply_with_ai;
  } catch {
    return false;
  }
};

// " and AI auto-replies" when the operator auto-sends, else "".
export const andAiAutoReplies = () => (aiAutoRepliesOn() ? ' and AI auto-replies' : '');

// Confirmation suffix for a pause; "" for suggest-only operators.
export const aiStillSuggests = () => (aiAutoRepliesOn() ? ' The AI will still suggest replies for your team.' : '');
